/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_ChargeInputs */

const en_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum charge: $3.00 USD`)
};

const fr_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais minimum : 3,00 $ US`)
};

const de_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestgebühr: 3,00 USD`)
};

const it_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo minimo: 3,00 USD`)
};

const ru_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная сумма заказа: 3,00 доллара США.`)
};

const es_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo mínimo: $3.00 USD`)
};

const zh_cn2_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低收费：3.00 美元`)
};

const ja_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低料金：3.00米ドル`)
};

const hi_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम शुल्क: $3.00 USD`)
};

const pt_pt2_minimum_charge = /** @type {(inputs: Minimum_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobrança mínima: US$ 3,00`)
};

/**
* | output |
* | --- |
* | "Minimum charge: $3.00 USD" |
*
* @param {Minimum_ChargeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_charge = /** @type {((inputs?: Minimum_ChargeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_ChargeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_minimum_charge(inputs)
	if (locale === "de") return de_minimum_charge(inputs)
	if (locale === "it") return it_minimum_charge(inputs)
	if (locale === "ru") return ru_minimum_charge(inputs)
	if (locale === "es") return es_minimum_charge(inputs)
	if (locale === "zh-CN") return zh_cn2_minimum_charge(inputs)
	if (locale === "ja") return ja_minimum_charge(inputs)
	if (locale === "hi") return hi_minimum_charge(inputs)
	if (locale === "pt-PT") return pt_pt2_minimum_charge(inputs)
	return en_minimum_charge(inputs)
});